/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li5_DescInputs */

const tr_iade_iptal_s9_li5_desc = /** @type {(inputs: Iade_Iptal_S9_Li5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İadeli taahhütlü posta ile:`)
};

const en_iade_iptal_s9_li5_desc = /** @type {(inputs: Iade_Iptal_S9_Li5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By registered mail with return receipt:`)
};

const de_iade_iptal_s9_li5_desc = /** @type {(inputs: Iade_Iptal_S9_Li5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per Einschreiben mit Rückschein:`)
};

const ru_iade_iptal_s9_li5_desc = /** @type {(inputs: Iade_Iptal_S9_Li5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказным письмом с уведомлением о вручении:`)
};

/**
* | output |
* | --- |
* | "By registered mail with return receipt:" |
*
* @param {Iade_Iptal_S9_Li5_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li5_desc = /** @type {((inputs?: Iade_Iptal_S9_Li5_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li5_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li5_desc(inputs)
	if (locale === "de") return de_iade_iptal_s9_li5_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li5_desc(inputs)
	return tr_iade_iptal_s9_li5_desc(inputs)
});